import request from '@/router/axios';

const urlPrefix = '/sys';

//根据代码集id获取代码集
export function getDicts(obj) {
  return request({
    url: urlPrefix + '/syscodeitem/getcodeitem',
    method: 'get',
    data: obj,
  });
}
//020201-05 根据当前用户 查询所有前端初始化代码项排除后的代码项 用来下拉先
export function getServerDictsList() {
  return request({
    url: urlPrefix + '/syscodeitem/getcodeitemlist',
    method: 'get',
  });
}
//020201-05 根据当前用户查询所有前端初始化代码项排除后的代码项 用来翻译
export function getServerDictsMap() {
  return request({
    url: urlPrefix + '/syscodeitem/getcodeitemmap',
    method: 'get',
  });
}

//020201-05 查询租户下的代码项集合
export function getDictsListBySetId(codeSetId) {
  return request({
    url: urlPrefix + '/code/api/tenantId/'+codeSetId+'/codeItem',
    method: 'get',
  });
}
